import { AiFillCheckCircle } from 'react-icons/ai'
import {
  BsBag,
  BsCashCoin,
  BsGraphUp,
  BsHandbagFill,
  BsPersonFill,
  BsThreeDots,
} from 'react-icons/bs'
import { CgFileDocument } from 'react-icons/cg'
import { FaCashRegister, FaShoppingBag } from 'react-icons/fa'
import { FiMinus } from 'react-icons/fi'
import { HiAdjustments, HiDocumentText, HiShoppingBag } from 'react-icons/hi'
import { IoMdAdd } from 'react-icons/io'
import {
  IoBarChartSharp,
  IoCalendar,
  IoCashSharp,
  IoDocuments,
  IoPersonAddSharp,
  IoWallet,
} from 'react-icons/io5'
import { SiGraphql } from 'react-icons/si'
import {
  Area,
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ComposedChart,
  LabelList,
  Legend,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { formatPipe, getDenomination } from '../../utils/utils'
import '../../layout/DashboardStats.css'
import { toFixed } from 'accounting'
import { FloatingMenuContext } from '../../context/FloatingMenuContext'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import Modal from '../../components/Display/Modal'
import { DashboardStatsClass } from '../../layout/DashboardClass'
import { ThemeContext } from '../../context/ThemeContext'
import { getJsonFromS3 } from '../../utils/UploadFile'
import { useHistory } from 'react-router'
import { BiMoney } from 'react-icons/bi'
import { useContext, useEffect, useState } from 'react'
import { IStats } from '../../layout/DashboardStats'
import Switch from '@mui/material/Switch'
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import InputText from '../../components/Inputs/InputText'
import Empty from '../../components/Display/Empty'
import Profile from '../../assets/images/profile.png'
import Button from '../../components/General/Button'
import axios from 'axios'

const server = process.env.REACT_APP_SERVER_URL

export const SalesView = () => {


  const history = useHistory()

  const [clientList, setClientList] = useState<any[]>([])

  const onSuggest = async (text: string) => {
    try {
      const res = await axios.get(
        `${server}/thirdparty/client?fastSearch=${text}&pageNumber=1&pageSize=10`
      )
      //console.log(res.data)
      const clientsToShow = res.data.clients?.map((client: any) => {
        return {
          ...client,
          id: client.id.toString(),
          title: client.name,
        }
      })

      setClientList(clientsToShow)
      //console.log(clientsToShow)
      // setSuggestionsList(precvClientsToShow => precvClientsToShow)

      // setLoading(false)
    } catch (error: any) {
      console.log(error?.message)
      // Alert.alert("Error", "No se pudo encontrar al cliente")
      // setLoading(false)
    }
  }

  console.log('CLIENT LIST', clientList)

  return (
    <div>
      <div className="w-full">
        <InputText
          placeholder="Ingresa Nro. Documento o nombre"
          onChangeValue={onSuggest}
        />
      </div>

      {clientList?.length > 0 ? (
        <>
          {clientList?.map((client) => (
            <div className="flex justify-between items-center mt-5" onClick={() =>history?.push("/sale-generate", client)}>
              <div>
                <div>
                  <label className='text-xs'>{client?.name}</label>
                </div>

                <div>
                  <label className='text-xs'>{`${client?.documentType}-${client?.document}`}</label>
                </div>
              </div>

              <div>
                <label className='text-xs'>{client?.email || 'Sin email'}</label>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          <div className="flex flex-col justify-center items-center">
            <img src={Profile} alt="zerux" className="mt-[100px]" />

            <label className="text-center text-gray">
              Ingresa un número de documento ó añade un nuevo cliente
            </label>

            <Button
              type="primary"
              classes="w-1/2 mt-5"
              onClick={() => history?.push('/create-client')}
            >
              Añadir cliente
            </Button>
          </div>
        </>
      )}

    

    </div>
  )
}
